import React from "react";
import { Loader, authActions, storeFromArea } from "@mc/mc-legacy";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import ProfilePage from "./pages/ProfilePage";

class WithAuthInfo extends React.Component<any> {
  componentDidMount(): void {
    this.props.dispatch(authActions.fetchAuthInfoIfNeeded());
  }

  componentDidUpdate(): void {
    this.props.dispatch(authActions.fetchAuthInfoIfNeeded());
  }

  render() {
    const { authInfo } = this.props;

    if (!authInfo.fetched) {
      return <Loader />;
    }

    return (
      <div>
        <Switch>
          <Route path="/profil" component={ProfilePage} />
          <Route component={() => <div />} />
        </Switch>
      </div>
    );
  }
}

export default withRouter(
  connect((state, props) => ({
    authInfo: storeFromArea(state, authActions.AUTH_INFO_AREA),
  }))(WithAuthInfo)
);
